export const DAY_HOURS = 24 * 60 * 60 * 1000;
export const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

const oldMessageDateFormat = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour12: true,
});

const yesterdayReadAtFormat = rtf.format(-1, 'day');
const oldReadAtFormat = new Intl.DateTimeFormat('en-US', {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric',
  hour12: true,
});

export function getMessageDateLabel(dateKey) {
  const givenDate = new Date(dateKey);

  if (isToday(givenDate)) {
    return capitalized(rtf.format(0, 'day'));
  } else if (isYesterday(givenDate)) {
    return capitalized(rtf.format(-1, 'day'));
  } else {
    return oldMessageDateFormat.format(givenDate);
  }
}

function formatDateWithTranslation(intl, date, translationKeyPrefix, name = null) {
  const givenDate = new Date(date);
  const formattedTime = formatDate(givenDate);
  const nameParam = name ? { name } : {};

  let translationKey, translationParams;
  if (isToday(givenDate)) {
    translationKey = name
      ? `${translationKeyPrefix}.today_with_name`
      : `${translationKeyPrefix}.today`;
    translationParams = { time: formattedTime };
  } else if (isYesterday(givenDate)) {
    translationKey = name
      ? `${translationKeyPrefix}.before_today_with_name`
      : `${translationKeyPrefix}.before_today`;
    translationParams = { date: yesterdayReadAtFormat, time: formattedTime };
  } else {
    const formattedDate = oldReadAtFormat.format(givenDate);
    translationKey = name
      ? `${translationKeyPrefix}.before_today_with_name`
      : `${translationKeyPrefix}.before_today`;
    translationParams = { date: formattedDate, time: formattedTime };
  }
  return intl.t(translationKey, { ...translationParams, ...nameParam });
}

export function formatReadAtDate(intl, date, name = null) {
  return formatDateWithTranslation(intl, date, 'emc.read_at', name);
}

export function formatDate(date) {
  const timeFormatter = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });

  return timeFormatter.format(new Date(date));
}

export const capitalized = str => str.charAt(0).toUpperCase() + str.slice(1);

export function formatDeletedAtDate(intl, date) {
  return formatDateWithTranslation(intl, date, 'emc.deleted_at');
}

function isToday(date) {
  const today = new Date();
  return date.toDateString() === today.toDateString();
}

function isYesterday(date) {
  const yesterday = new Date(new Date().getTime() - DAY_HOURS);
  return date.toDateString() === yesterday.toDateString();
}
